module.exports = __webpack_public_path__ + "img/ag.0f53e8a0.svg";